import styled from 'styled-components';

export const ProfileSvg = styled.svg`
    height: 100%;
`;

export const DiveProfileContainer = styled.div`
    position: relative;
`;
